import React, { useEffect, useRef, useState } from "react";
import { pageClass, pageHeader } from "../Components/Utils/CustomClasses";
import Table from "../Components/Table/Table";
import AddAdmin from "./AddAdmin";
import { GetAllAdminUserAPI, GetAllCompanyAPI } from "../API/Api";
import { useSelector } from "react-redux";
import { useThemeColor } from "../Components/Sidebar/SideBarApi"; 
import ViewAdminDetailsModal from "../Components/Modals/ViewAdminDetailsModal";
import DeleteAdminUserModal from "../Components/Modals/DeleteAdminUserModal";
import usePaginatedData from "../Components/Utils/UsePagination";
import { useForm } from "react-hook-form";
import { IconEye } from "@tabler/icons-react";

export default function Admin() {
  const userDetails = useSelector((state) => state?.login?.userDetails);
  const [Company, setCompany] = useState([]);
  const [AdminModal, setAdminModal] = useState(false);
  const [rowdata, setrowdata] = useState([]);
  const filterTimeout = useRef();
  const isFirstRender = useRef(true);  
  const { register } = useForm();
  const themeColor = useThemeColor(); 

  const initialFilterState = {
    p: 1,
    company: "",
    search: "",
    id: userDetails?._id ? userDetails?._id : "", 
  };
  const [filterObject, setFilterObject] = useState({ ...initialFilterState });
  const {filterData: AdminUser,pageNo,pageChangeHandler,recordChangeHandler,fetchData,prevIsValid,nextIsValid,loader} = usePaginatedData(1, 50, GetAllAdminUserAPI, filterObject);

  const filterRecords = () => {
    if (filterTimeout.current) {
      clearTimeout(filterTimeout.current);
    }
    filterTimeout.current = setTimeout(async () => {
      await fetchData({ ...filterObject });
      filterTimeout.current = null;
    }, 1500);

    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
      }
    };
  };

  const getallCompany = async (companyid) => {
    try {
      let response = await GetAllCompanyAPI(companyid);
      setCompany(response?.data?.filteredData);
    } catch (err) {
      console.log("Error:", err);
    }
  };

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    filterRecords();
  }, [filterObject]);

  const HandleViewAdmin = (row) => {
    setrowdata(row);
    setAdminModal(true);
  };
  const tableColumns = [
    {
      field: "name",
      header: "Full Name",
      style: true,
      className: "col-name",
      body: (row) => {
        const firstName = row?.first_name || "";
        const lastName = row?.last_name || "";
        const fullName = (firstName && lastName) ? `${firstName} ${lastName}` : firstName || lastName || "-----";
        return <h6>{fullName}</h6>;
      },
    },
    {
      field: "email",
      header: "Email",
      style: true,
      body: (row) => <h6>{row?.email}</h6>,
    },
    {
      field: "phone_number",
      header: "Phone Number",
      style: true,
      body: (row) => <h6>{row?.phone_number}</h6>,
    },
    {
      field: "role",
      header: "Role",
      style: true,
      body: (row) => <h6>{row?.role?.roleName}</h6>,
    },
    {
      field: "company",
      header: "Company",
      style: true,
      body: (row) => <h6>{row?.company?.companyName}</h6>,
    },
    {
      field: "actions",
      header: "Actions",
      style: true,
      body: (row) => (
        <div className="flex items-center w-full gap-x-2">
          <button
            className="py-1 rounded-lg flex justify-center w-1/2"
            onClick={(e) => {
              e.preventDefault();
              HandleViewAdmin(row);
            }}
          >
            <IconEye stroke={1.5} size={24} color="#000" />
          </button>
          <AddAdmin edit={true} rowdata={row} filterRecords={filterRecords} />
          <DeleteAdminUserModal data={row} filterRecords={filterRecords} />
        </div>
      ),
    },
  ];

  useEffect(() => {
    getallCompany(userDetails?.company?._id);
  }, []);
  return (
    <>
      <div className={`${pageClass}`}>
        <div className="bg-[#FFFFFF] p-10 rounded-xl">
          <div className="flex items-center justify-between">
            <h1 className={`${pageHeader}`}>Admin</h1>
            <AddAdmin
              edit={false}
              Company={Company}
              filterRecords={filterRecords}
            />
          </div>
          <div className="mt-4">
            <Table
              columns={tableColumns}
              data={AdminUser}
              paginatorCheck={true}
              prevIsValid={prevIsValid}
              nextIsValid={nextIsValid}
              pageNo={pageNo}
              pageChangeHandler={pageChangeHandler}
              recordChangeHandler={recordChangeHandler}
              register={register}
              loading={loader}
            />
          </div>
          <ViewAdminDetailsModal
            AdminModal={AdminModal}
            setAdminModal={setAdminModal}
            data={rowdata}
          />
        </div>
      </div>
    </>
  );
}
